import { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { useLocation } from 'react-router';
import { addrecordedQuestions, deleteRecordedQuestions, getrecordedQuestions, isOpenModal, ModalToggle, updaterecordedQuestions, } from '../../store/recordedQuestionsSlice';
import DOMPurify from 'dompurify';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CustomUploadAdapterPlugin } from '../../utils/MyUploadAdapter';


const RecordedQuestionsTable = () => {
  const storeVar = useSelector(state => state.recordedQuestion)
  const dispatch = useDispatch();
  const location = useLocation();
  const toggle = () => dispatch(ModalToggle());
  const [mainId, setmainId] = useState()
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
    modalTitle: null,
    editState: false,
    questionId: '',
    questionEnglish: '',
    questionBengali: '',
    answer1English: '',
    answer1Bengali: '',
    answer2English: '',
    answer2Bengali: '',
    answer3English: '',
    answer3Bengali: '',
    answer4English: '',
    answer4Bengali: '',
    correctAnswer: '1',
    answerJustificationEnglish: '',
    answerJustificationBengali: '',
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id") || "";
    setmainId(id);

    dispatch(getrecordedQuestions(formVar.limit, formVar.offset, id))
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset

    }))
    dispatch(getrecordedQuestions(formVar.limit, offset, mainId))
  };

  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      modalTitle: 'Edit Question',
      questionId: data._id,
      questionEnglish: data.questionEnglish,
      questionBengali: data.questionBengali,
      answer1English: data.answer1English,
      answer1Bengali: data.answer1Bengali,
      answer2English: data.answer2English,
      answer2Bengali: data.answer2Bengali,
      answer3English: data.answer3English,
      answer3Bengali: data.answer3Bengali,
      answer4English: data.answer4English,
      answer4Bengali: data.answer4Bengali,
      correctAnswer: data.correctAnswer,
      answerJustificationEnglish: data.answerJustificationEnglish,
      answerJustificationBengali: data.answerJustificationBengali,

    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Question',
      questionId: '',
      questionEnglish: '',
      questionBengali: '',
      answer1English: '',
      answer1Bengali: '',
      answer2English: '',
      answer2Bengali: '',
      answer3English: '',
      answer3Bengali: '',
      answer4English: '',
      answer4Bengali: '',
      correctAnswer: '1',
      answerJustificationEnglish: '',
      answerJustificationBengali: '',
    }))
  }


  const submitMenu = () => {

    if (formVar.editState) {
      dispatch(updaterecordedQuestions(formVar.questionId, {
        questionEnglish: formVar.questionEnglish,
        questionBengali: formVar.questionBengali,
        answer1English: formVar.answer1English,
        answer1Bengali: formVar.answer1Bengali,
        answer2English: formVar.answer2English,
        answer2Bengali: formVar.answer2Bengali,
        answer3English: formVar.answer3English,
        answer3Bengali: formVar.answer3Bengali,
        answer4English: formVar.answer4English,
        answer4Bengali: formVar.answer4Bengali,
        correctAnswer: formVar.correctAnswer,
        answerJustificationEnglish: formVar.answerJustificationEnglish,
        answerJustificationBengali: formVar.answerJustificationBengali,
      }))
    } else {
      dispatch(addrecordedQuestions({
        lectureId: mainId,
        questionEnglish: formVar.questionEnglish,
        questionBengali: formVar.questionBengali,
        answer1English: formVar.answer1English,
        answer1Bengali: formVar.answer1Bengali,
        answer2English: formVar.answer2English,
        answer2Bengali: formVar.answer2Bengali,
        answer3English: formVar.answer3English,
        answer3Bengali: formVar.answer3Bengali,
        answer4English: formVar.answer4English,
        answer4Bengali: formVar.answer4Bengali,
        correctAnswer: formVar.correctAnswer,
        answerJustificationEnglish: formVar.answerJustificationEnglish,
        answerJustificationBengali: formVar.answerJustificationBengali,
      }))
    }
  }




  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(deleteRecordedQuestions(data._id))
        }
      });
  }


  // Question
  const onChangeQuestionEnglish = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, questionEnglish: evt }))
  };
  const onFocusQuestionEnglish = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, questionEnglish: evt }))
  }
  const onChangeQuestionBengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, questionBengali: evt }))
  };
  const onFocusQuestionBengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, questionBengali: evt }))
  }
  const onChangeAnswer1English = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer1English: evt }))
  };
  const onFocusAnswer1English = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer1English: evt }))
  }
  const onChangeAnswer1Bengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer1Bengali: evt }))
  };
  const onFocusAnswer1Bengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer1Bengali: evt }))
  }
  //Answer2
  const onChangeAnswer2English = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer2English: evt }))
  };
  const onFocusAnswer2English = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer2English: evt }))
  }
  const onChangeAnswer2Bengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer2Bengali: evt }))
  };
  const onFocusAnswer2Bengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer2Bengali: evt }))
  }
  //Answer3
  const onChangeAnswer3English = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer3English: evt }))
  };
  const onFocusAnswer3English = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer3English: evt }))
  }
  const onChangeAnswer3Bengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer3Bengali: evt }))
  };
  const onFocusAnswer3Bengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer3Bengali: evt }))
  }
  //Answer 4
  const onChangeAnswer4English = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer4English: evt }))
  };
  const onFocusAnswer4English = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer4English: evt }))
  }
  const onChangeAnswer4Bengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer4Bengali: evt }))
  };
  const onFocusAnswer4Bengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answer4Bengali: evt }))
  }
  // Answer Justification
  const onChangeAnswerJustificationEnglish = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answerJustificationEnglish: evt }))
  };
  const onFocusAnswerJustificationEnglish = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answerJustificationEnglish: evt }))
  }
  const onChangeAnswerJustificationBengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answerJustificationBengali: evt }))
  };
  const onFocusAnswerJustificationBengali = (editor) => {
    const evt = editor.getData()
    setFormVar((prevFormVar) => ({ ...prevFormVar, answerJustificationBengali: evt }))
  }

  const handleInputChange = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, correctAnswer: e.target.value }))
  };


  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">
              </Col>
              <Col md="4">
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Questions
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Question in English</th>
                  <th scope='col'>Question in Bengali</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.recordedQuestionsData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td
                      className="questionImage"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item.questionEnglish, {
                          ADD_TAGS: ['img'],
                          ADD_ATTR: ['src', 'alt', 'width', 'height', 'style'],
                        }),
                      }}
                    ></td>
                    <td
                      className="questionImage"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item.questionBengali, {
                          ADD_TAGS: ['img'],
                          ADD_ATTR: ['src', 'alt', 'width', 'height', 'style'],
                        }),
                      }}
                    ></td>


                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalrecordedQuestions <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalrecordedQuestions > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalrecordedQuestions}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} size={'xl'} >
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Question in English</Label>
            <CKEditor
              editor={ClassicEditor}
              data={formVar.questionEnglish || ''}
              onReady={editor => {
                onFocusQuestionEnglish(editor)
              }}
              onFocus={(event, editor) => {
                onFocusQuestionEnglish(editor)
              }}
              onChange={(event, editor) => {
                onChangeQuestionEnglish(editor);
              }}
              onBlur={(event, editor) => {
              }}
              config={{
                extraPlugins: [CustomUploadAdapterPlugin],
              }}
            />
            <Label className="col-form-label" for="recipient-name">Question in Bengali</Label>
            <CKEditor
              editor={ClassicEditor}
              data={formVar.questionBengali || ''}
              onReady={editor => {
                onFocusQuestionBengali(editor)
              }}
              onFocus={(event, editor) => {
                onFocusQuestionBengali(editor)
              }}
              onChange={(event, editor) => {
                onChangeQuestionBengali(editor);
              }}
              onBlur={(event, editor) => {
              }}
              config={{
                extraPlugins: [CustomUploadAdapterPlugin],
              }}
            />
            <Row>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Answer 1 in English</Label>
                <CKEditor
                  editor={ClassicEditor}
                  data={formVar.answer1English || ''}
                  onReady={editor => {
                    onFocusAnswer1English(editor)
                  }}
                  onChange={(event, editor) => {
                    onChangeAnswer1English(editor);
                  }}
                  onBlur={(event, editor) => {
                  }}
                  onFocus={(event, editor) => {
                    onFocusAnswer1English(editor)
                  }}
                  config={{
                    extraPlugins: [CustomUploadAdapterPlugin],
                  }}
                />
              </Col>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Answer 1 in Bengali</Label>
                <CKEditor
                  editor={ClassicEditor}
                  data={formVar.answer1Bengali || ''}
                  onReady={editor => {
                    onFocusAnswer1Bengali(editor)
                  }}
                  onChange={(event, editor) => {
                    onChangeAnswer1Bengali(editor);
                  }}
                  onBlur={(event, editor) => {
                  }}
                  onFocus={(event, editor) => {
                    onFocusAnswer1Bengali(editor)
                  }}
                  config={{
                    extraPlugins: [CustomUploadAdapterPlugin],
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Answer 2 in English</Label>
                <CKEditor
                  editor={ClassicEditor}
                  data={formVar.answer2English || ''}
                  onReady={editor => {
                    onFocusAnswer2English(editor)
                  }}
                  onChange={(event, editor) => {
                    onChangeAnswer2English(editor);
                  }}
                  onBlur={(event, editor) => {
                  }}
                  onFocus={(event, editor) => {
                    onFocusAnswer2English(editor)
                  }}
                  config={{
                    extraPlugins: [CustomUploadAdapterPlugin],
                  }}
                />
              </Col>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Answer 2 in Bengali</Label>
                <CKEditor
                  editor={ClassicEditor}
                  data={formVar.answer2Bengali || ''}
                  onReady={editor => {
                    onFocusAnswer2Bengali(editor)
                  }}
                  onChange={(event, editor) => {
                    onChangeAnswer2Bengali(editor);
                  }}
                  onBlur={(event, editor) => {
                  }}
                  onFocus={(event, editor) => {
                    onFocusAnswer2Bengali(editor)
                  }}
                  config={{
                    extraPlugins: [CustomUploadAdapterPlugin],
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Answer 3 in English</Label>
                <CKEditor
                  editor={ClassicEditor}
                  data={formVar.answer3English || ''}
                  onReady={editor => {
                    onFocusAnswer3English(editor)
                  }}
                  onChange={(event, editor) => {
                    onChangeAnswer3English(editor);
                  }}
                  onBlur={(event, editor) => {
                  }}
                  onFocus={(event, editor) => {
                    onFocusAnswer3English(editor)
                  }}
                  config={{
                    extraPlugins: [CustomUploadAdapterPlugin],
                  }}
                />
              </Col>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Answer 3 in Bengali</Label>
                <CKEditor
                  editor={ClassicEditor}
                  data={formVar.answer3Bengali || ''}
                  onReady={editor => {
                    onFocusAnswer3Bengali(editor)
                  }}
                  onChange={(event, editor) => {
                    onChangeAnswer3Bengali(editor);
                  }}
                  onBlur={(event, editor) => {
                  }}
                  onFocus={(event, editor) => {
                    onFocusAnswer3Bengali(editor)
                  }}
                  config={{
                    extraPlugins: [CustomUploadAdapterPlugin],
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Answer 4 in English</Label>
                <CKEditor
                  editor={ClassicEditor}
                  data={formVar.answer4English || ''}
                  onReady={editor => {
                    onFocusAnswer4English(editor)
                  }}
                  onChange={(event, editor) => {
                    onChangeAnswer4English(editor);
                  }}
                  onBlur={(event, editor) => {
                  }}
                  onFocus={(event, editor) => {
                    onFocusAnswer4English(editor)
                  }}
                  config={{
                    extraPlugins: [CustomUploadAdapterPlugin],
                  }}
                />
              </Col>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Answer 4 in Bengali</Label>
                <CKEditor
                  editor={ClassicEditor}
                  data={formVar.answer4Bengali || ''}
                  onReady={editor => {
                    onFocusAnswer4Bengali(editor)
                  }}
                  onChange={(event, editor) => {
                    onChangeAnswer4Bengali(editor);
                  }}
                  onBlur={(event, editor) => {
                  }}
                  onFocus={(event, editor) => {
                    onFocusAnswer4Bengali(editor)
                  }}
                  config={{
                    extraPlugins: [CustomUploadAdapterPlugin],
                  }}
                />
              </Col>
            </Row>
            <Label className="col-form-label" for="recipient-name">Correct Answer</Label>
            <Col md="4">
              <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                value={formVar.correctAnswer} onChange={handleInputChange}>
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
                <option value='4'>4</option>
              </Input>
            </Col>
            <Label className="col-form-label" for="recipient-name">Answer Explanation in English</Label>
            <CKEditor
              editor={ClassicEditor}
              data={formVar.answerJustificationEnglish || ''}
              onReady={editor => {
                onFocusAnswerJustificationEnglish(editor)
              }}
              onFocus={(event, editor) => {
                onFocusAnswerJustificationEnglish(editor)
              }}
              onChange={(event, editor) => {
                onChangeAnswerJustificationEnglish(editor);
              }}
              onBlur={(event, editor) => {
              }}
              config={{
                extraPlugins: [CustomUploadAdapterPlugin],
              }}
            />
            <Label className="col-form-label" for="recipient-name">Answer Explanation in Bengali</Label>
            <CKEditor
              editor={ClassicEditor}
              data={formVar.answerJustificationBengali || ''}
              onReady={editor => {
                onFocusAnswerJustificationBengali(editor)
              }}
              onFocus={(event, editor) => {
                onFocusAnswerJustificationBengali(editor)
              }}
              onChange={(event, editor) => {
                onChangeAnswerJustificationBengali(editor);
              }}
              onBlur={(event, editor) => {
              }}
              config={{
                extraPlugins: [CustomUploadAdapterPlugin],
              }}
            />
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default RecordedQuestionsTable;
